import { render } from "./AlbumsGrid.vue?vue&type=template&id=6dc1dc24&scoped=true"
import script from "./AlbumsGrid.vue?vue&type=script&lang=js"
export * from "./AlbumsGrid.vue?vue&type=script&lang=js"

import "./AlbumsGrid.vue?vue&type=style&index=0&id=6dc1dc24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6dc1dc24"

export default script